import { http } from '../../config/axios'

 const findSaldoClienteMovimentoService = (params:any): Promise<any> => {
  const queryParams = params
                ? Object.keys(params)
                      .map((k) => encodeURIComponent(params[k]))
                      .join('/')
                : '';
  return http
    .get('api/cliente-saldo-movimento/find/' + queryParams)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro findSaldoClienteMovimentoService', error)
      throw Error(error.response.data)
    })
}

export default findSaldoClienteMovimentoService;
